import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h35v35H0V0Zm18.539 9.934a4.615 4.615 0 0 1 6.527 6.527l-3.82 3.82a4.582 4.582 0 0 1-6.54-.005 1.235 1.235 0 1 1 1.764-1.728 2.111 2.111 0 0 0 3.016 0l.009-.01 3.824-3.823a2.146 2.146 0 0 0-3.034-3.034l-.478.478a1.235 1.235 0 1 1-1.746-1.747l.478-.478Zm-1.517 3.414a4.581 4.581 0 0 0-3.267 1.37l-3.82 3.82a4.615 4.615 0 0 0 6.526 6.528l.478-.478a1.235 1.235 0 0 0-1.746-1.747l-.478.478a2.145 2.145 0 0 1-3.034-3.034l3.824-3.824.01-.009a2.112 2.112 0 0 1 3.015 0 1.235 1.235 0 0 0 1.765-1.729 4.582 4.582 0 0 0-3.273-1.375Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgLink;